var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigurationRollback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14092_20343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 27C12.4 27 8.9 25.2 6.8 22H12V20H4V28H6V24.3C8.5 27.3 12.1 29 16 29V27Z",
    fill: "#E753BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 23V21H28.9C28.8 20.4 28.5 19.8 28.2 19.2L29.7 17.7L28.3 16.3L26.8 17.8C26.3 17.5 25.7 17.2 25 17.1V15H23V17.1C22.4 17.2 21.8 17.5 21.2 17.8L19.7 16.3L18.3 17.7L19.8 19.2C19.5 19.7 19.2 20.3 19.1 21H17V23H19.1C19.2 23.6 19.5 24.2 19.8 24.8L18.3 26.3L19.7 27.7L21.2 26.2C21.7 26.5 22.3 26.8 23 26.9V29H25V26.9C25.6 26.8 26.2 26.5 26.8 26.2L28.3 27.7L29.7 26.3L28.2 24.8C28.5 24.3 28.8 23.7 28.9 23H31ZM24 25C22.3 25 21 23.7 21 22C21 20.3 22.3 19 24 19C25.7 19 27 20.3 27 22C27 23.7 25.7 25 24 25Z",
    fill: "#E753BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10H25.2C21.9 4.9 15.1 3.5 10 6.8C6.9 8.8 5 12.3 5 16H3C3 8.8 8.8 3 16 3C19.9 3 23.5 4.7 26 7.7V4H28V12H20V10Z",
    fill: "#E753BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14092_20343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurationRollback);
export default __webpack_public_path__ + "static/media/Configuration Rollback.d41b9ae20c661c2c61926ab3d390fe9e.svg";
export { ForwardRef as ReactComponent };